import React from "react";
import FormOne from "../contact/RegistrationForm";
import Accordion from "react-bootstrap/Accordion";
import { FaChalkboardTeacher, FaLaptopCode, FaUserGraduate } from "react-icons/fa";

const AboutTwo = () => {
  return (
    <div className="section-padding">
      <div className="container">
        <div className="row">
          {/* Left Side Content */}
          <div className="col-lg-6">
            <div className="why-choose-us">
              <div className="section-heading heading-left">
                <span className="subtitle">About Us</span>
                <h3 className="title">Empowering Future Tech Talent</h3>
                <p>
                  At <strong>NewWayIT Education</strong>, we’re dedicated to transforming learners into skilled professionals. Our project-based training and expert mentorship help students master Web Development, App Development, Cyber Security, AI & ML, and more. We don’t just teach—we build careers.
                </p>
              </div>

              <Accordion defaultActiveKey="1">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <FaChalkboardTeacher /> Hands-on Learning
                  </Accordion.Header>
                  <Accordion.Body>
                    Our courses are built around practical application. Students work on real-time projects and gain experience that mirrors industry work environments—ensuring they’re job-ready from day one.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <FaLaptopCode /> Industry-Relevant Courses
                  </Accordion.Header>
                  <Accordion.Body>
                    We offer training in high-demand fields like full-stack development, mobile app development, AI/ML, and cyber security. All content is regularly updated to reflect the latest tools and technologies.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <FaUserGraduate /> Mentorship & Career Support
                  </Accordion.Header>
                  <Accordion.Body>
                    Beyond teaching, we provide 1-on-1 mentorship, resume guidance, portfolio help, and interview preparation—so our students can confidently step into their professional careers.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          {/* Right Side Form */}
          <div className="col-xl-5 col-lg-6 offset-xl-1">
            <div className="contact-form-box shadow-box mb--30">
              <h3 className="title">Register for a Demo Class</h3>
              <FormOne />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTwo;
